<div edsRow>
  <div edsCol>
    <ng-container *ngFor="let button of buttonsCollection">
      <a
        [href]="button.href"
        [target]="button.target"
        [ngClass]="button.externalLinkClass"
        [edsButton]="button.buttonStyle"
        (click)="checkSignIn($event, button.linkCompound)"
        >{{ button.ctaText }}</a
      >
    </ng-container>
  </div>
</div>
